import albImageSlider from "./../../templates/albImageSlider.dust";
import spinner from "./../../templates/spinner.dust";

import {
  CLICKED_IMAGE_ALB,
  SWIPED_FORWARD_IMAGEVIEWER,
  SWIPED_BACKWARD_IMAGEVIEWER,
} from "./../../analytics/analyticsevents";

export default class AlbImageSlider {
  appState = null;
  DOMContainer = null;
  loaderDOMContainer = null;
  options = null;

  renderingDone = false;
  //if allready added to alb
  added = false;
  canAdd = false;
  rotated = false;

  ratios = [];

  //TODO: check the swiper.update(); probably called to often but otherwise rotation breaks
  constructor(appState, DOMContainer, context, options) {
    this.appState = appState;
    this.DOMContainer = DOMContainer;
    this.options = options;
    this.context = context;
    this.appState.on("appState:heightChanged", () => {
      if (this.swiper) {
        if (this.canAdd && this.renderingDone) {
          this.setImagesHeight();
          this.swiper.update();
          this.rotated = true;
        }
      }
    });
  }

  render() {
    for (let i = 0; i < this.context.images.length; i++) {
      this.context.images[i].imageIdentifier = "image_" + i; //identify each image in the ALB for easy image loading
    }
    Dust.render(albImageSlider, this.context, (err, result) => {
      $(this.DOMContainer).html(result);
      const images = [...this.context.images];
      const promises = [];
      for (let i = 0; i < images.length; i++) {
        const image = images[i];
        const element = this.DOMContainer.querySelector(
          "." + image.imageIdentifier
        );
        promises.push(
          this.appState.cdnAssetsDownloader.loadImageOnElement(
            this.options.sizes.nonHD,
            image.ContentItemId,
            element,
            true,
            false
          )
        );
      }
      Promise.all(promises).then((ratios) => {
        this.ratios = ratios;
        this.renderingDone = true;
        this.addToAlb();
        this.attatchClickHandlers();
      });
    });
  }

  attatchClickHandlers() {
    this.DOMContainer.querySelector(
      ".alb-image-slider-wrapper"
    ).addEventListener("click", () => {
      this.openImageViewer();
    });
  }

  openImageViewer() {
    this.renderLoader();
    const slide = this.swiper.activeIndex;
    if (this.appState.isDesktop) {
      const ImageGallery = require("./../imageGallery").default;
      new ImageGallery({
        appState: this.appState,
        slideNumber: slide,
        context: this.context,
        options: this.options.imageviewer,
        loadedCallback: this.imageGalleryLoadedCallback,
        loopSwiper: this.loopSwiper(),
      });
    } else {
      const ImageGalleryMobile =
        require("./../../../touch/reader/components/imageGallery/imageGalleryMobile").default;
      new ImageGalleryMobile({
        appState: this.appState,
        slideNumber: slide,
        context: this.context,
        options: this.options.imageviewer,
        loadedCallback: this.imageGalleryLoadedCallback,
        loopSwiper: this.loopSwiper(),
      });
    }
    this.appState.triggerEvent(CLICKED_IMAGE_ALB);
  }

  update() {
    if (this.swiper) {
      this.swiper.update();
      this.swiper.slideTo(this.swiper.activeIndex);
      this.swiper.update();
    }
  }

  onAddedToAlb() {
    if (this.swiper) {
      if (this.rotated) {
        this.setImagesHeight();
        this.swiper.update();
        this.rotated = false;
      }
      return;
    }
    this.canAdd = true;
    this.addToAlb();
  }

  addToAlb() {
    if (this.canAdd && this.renderingDone) {
      //if not yet added to alb and can add and rendering is done
      this.createSwiper();
    }
  }

  createSwiper() {
    this.swiper = new Swiper(this.DOMContainer, {
      pagination: $(this.DOMContainer).find(" .swiper-pagination-alb-image"),
      paginationClickable: true,
      initialSlide: 0,
      spaceBetween: 20,
      centeredSlides: true,
      nested: true,
      loopedSlides: this.DOMContainer.querySelector(".alb-image-slider-wrapper")
        .children.length,
      loop: this.loopSwiper(),
      onSlideNextEnd: () => {
        this.appState.triggerEvent(SWIPED_FORWARD_IMAGEVIEWER);
      },
      onSlidePrevEnd: () => {
        this.appState.triggerEvent(SWIPED_BACKWARD_IMAGEVIEWER);
      },
    });
    this.setImagesHeight();
  }

  setImagesHeight() {
    const $slides = $(this.DOMContainer).find(".swiper-slide-alb-img");
    $slides.map((i, slide) => {
      this.setImageHeight(slide, this.ratios[i]);
    });
    this.swiper.update();
  }

  setImageHeight(slide, ratioImg) {
    const container = slide.querySelector(".alb-slide-img-container");
    if (container) {
      const DOMContainer = document.querySelector("#alb");
      if (DOMContainer) {
        const image = container.querySelector(".alb-slide-img");
        if (image) {
          image.classList.remove("hidden");
          if (this.options.fullWidthImage) {
            image.setAttribute("style", "width: 100%;");
          } else {
            const isHidden = DOMContainer.classList.contains("hidden");
            if (isHidden) {
              DOMContainer.classList.remove("hidden");
            }
            const rect = container.getBoundingClientRect();
            if (isHidden) {
              DOMContainer.classList.add("hidden");
            }
            const ratioContainer = rect.height / rect.width;
            if (ratioImg < ratioContainer) {
              image.style.removeProperty("height");
              // image.setAttribute('style', 'width: 100%;');   //TODO: 100% doesnt work on IOS but then there are no flickers when rotating
              image.setAttribute("style", `width: ${rect.width}px;`);
            } else {
              image.style.removeProperty("width");
              image.setAttribute("style", "height: 100%;");
            }
            container.classList.add("loaded");
          }
        }
      }
    }
  }

  getMainImageSrc() {
    if (!this.context.images || this.context.images.length <= 0) {
      return undefined;
    }
    return this.appState.cdnAssetsDownloader.getImageSrc(
      this.options.sizes.nonHD,
      this.context.images[0].ContentItemId
    );
  }

  loopSwiper = () => {
    return !this.context.singleImage && this.appState.isDesktop;
  };

  imageGalleryLoadedCallback = () => {
    this.DOMContainer.classList.remove("image-viewer-loading");
  };

  renderLoader() {
    this.loaderDOMContainer = this.DOMContainer.querySelector(
      ".alb-image-slider-viewer-loader"
    );
    if (this.loaderDOMContainer && !this.loaderDOMContainer.hasChildNodes()) {
      Dust.render(spinner, {}, (err, result) => {
        this.loaderDOMContainer.innerHTML = result;
        this.DOMContainer.classList.add("image-viewer-loading");
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/components/articleLightbox/albImageSlider.js